import Api from '@/api/index'

const state = {
  approved: [],
  deliver: [],
  fd: [],
  payment: [],
  denied: [],
  reinit: [],
}

const getters = {}

const actions = {
  async getAll({ commit }, params) {
    const invoices = await Api.Transit.getAll(params)
    const urlParams = new URLSearchParams(params)
    const status = urlParams.get('status')

    if (invoices !== null && status !== null) {
      if (status === 'approved') {
        commit('setInvoicesApproved', invoices)
      } else if (status === 'deliver') {
        commit('setInvoicesDeliver', invoices)
      } else if (status === 'fd') {
        commit('setInvoicesFD', invoices)
      } else if (status === 'payment') {
        commit('setInvoicesPayment', invoices)
      } else if (status === 'denied') {
        commit('setInvoicesDenied', invoices)
      } else if (status === 'reinit') {
        commit('setInvoicesReinit', invoices)
      }
      return invoices
    }
    return []
  },
  async startTransit(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    let result = await Api.Transit.startTransit(params)
    return result
  },
  async caseReady(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.caseReady(params)
    return result
  },

  async controlNumber(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.controlNumber(params)
    return result
  },

  async denied(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.denied(params)
    return result
  },

  async approve(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.approve(params)
    return result
  },

  async payInvoice(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.payInvoice(params)
    return result
  },

  async delivered(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.delivered(params)
    return result
  },

  async deliveredAttachment(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.deliveredAttachment(params)
    return result
  },

  async reinitTransit(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.reinitTransit(params)
    return result
  },

  async sendEmailsDenied(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Transit.sendEmailsDenied(params)
    return result
  },
}

const mutations = {
  setInvoicesApproved(state, invoices) {
    state.approved = invoices.items
  },
  setInvoicesDeliver(state, invoices) {
    state.deliver = invoices.items
  },
  setInvoicesFD(state, invoices) {
    state.fd = invoices.items
  },
  setInvoicesPayment(state, invoices) {
    state.payment = invoices.items
  },
  setInvoicesDenied(state, invoices) {
    state.denied = invoices.items
  },
  setInvoicesreInit(state, invoices) {
    state.reinit = invoices.items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
